"use client";

import Describe from "../Chat/Charts/token/About/Describe";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/TokenDetails/WhatIsSymbol";
import { ViewMoreButton } from "./ViewMoreButton";
import { cn } from "utils";
import { memo } from "react";

const I18n = I18nUtil.createScoped(Translations);

interface WhatIsSymbolProps {
  /** 币种符号，例如 BTC */
  symbol: string;
  /** 币种描述内容 */
  description: string;
  /** 容器自定义类名 */
  className?: string;
  /** 币种名称，例如 Bitcoin */
  name?: string;
}

const WhatIsSymbol = memo(
  ({
    symbol = "BTC",
    description = "",
    className,
    name,
  }: WhatIsSymbolProps) => {
    if (!description) {
      return null;
    }

    return (
      <div className={cn("", className)}>
        <h2
          aria-label="What Is Symbol h2"
          data-openreplay-label="What Is Symbol h2 Semantic"
          id="sem-what-is-symbol-h2"
          className="headline_regular_s text-content_primary mb-3"
        >
          {!!name
            ? I18n.t("What is %{var0} (%{var1})?", {
                var0: name,
                var1: symbol,
              })
            : I18n.t("What is %{var0}?", {
                var0: symbol,
              })}
        </h2>
        <Describe
          desc={description}
          maxLines={3}
          lineClampClassName="line-clamp-3"
          viewMoreText={<ViewMoreButton iconSize={12} />}
          contentClassName="text-content_primary !button_s !body_m"
          viewMoreClassName="text-content_tertiary !button_s"
        />
      </div>
    );
  },
);

WhatIsSymbol.displayName = "WhatIsSymbol";

export { WhatIsSymbol };
export type { WhatIsSymbolProps };
